import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";

export default <T,>({ name, label, formik, valueAsCorrectType, correctTypeAsValue, onChange, children }: ISelectProps<T>) => {
    return (
        <InputContainer label={label} name={name} formik={formik}>
            <SelectInputSlim name={name} formik={formik} valueAsCorrectType={valueAsCorrectType} correctTypeAsValue={correctTypeAsValue} onChange={onChange}>
                {children}
            </SelectInputSlim>
        </InputContainer>
    );
}

export const SelectInputRow = <T,>({ name, label, formik, valueAsCorrectType, correctTypeAsValue, onChange, children }: ISelectProps<T>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik}>
            <SelectInputSlim name={name} formik={formik} valueAsCorrectType={valueAsCorrectType} correctTypeAsValue={correctTypeAsValue} onChange={onChange}>
                {children}
            </SelectInputSlim>
        </InputContainerRow>
    );
}

export const SelectInputSlim = <T,>({ name, formik, valueAsCorrectType, correctTypeAsValue, onChange, children }: ISlimSelectProps<T>) => {
    return (
        <select
            name={name as string}
            value={correctTypeAsValue ? correctTypeAsValue(formik.values[name]) : (formik.values[name] as string || "")}
            onChange={e => formik.setValues({
                ...formik.values,
                [name]: valueAsCorrectType(e.target.value) || null,
                ...onChange ? onChange(e.target.value) : {},
            })}
            onBlur={formik.handleBlur}
        >
            {children}
        </select>
    );
}

interface ISelectProps<T> extends IInputProps<T, string> {
    valueAsCorrectType: (value: string) => T[keyof T];
    correctTypeAsValue?: (value: T[keyof T]) => string;
    children: React.ReactNode[];
}

interface ISlimSelectProps<T> extends ISlimInputProps<T, string> {
    valueAsCorrectType: (value: string) => T[keyof T];
    correctTypeAsValue?: (value: T[keyof T]) => string;
    children: React.ReactNode[];
}